import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import { citizenDashboardDetails } from "../../Services/getServices";
import { citizenSchemeDetails } from "../../Services/getServices";
import { loader } from "../../redux/type";
import { Link } from "react-router-dom";
import Slider from 'react-slick';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { adminUserDomainDetails } from "../../Services/postServices";

const DeptUserDashboard=()=>{

  const dispatch = useDispatch();
  const token=localStorage.getItem("token");

  const userData = JSON.parse(localStorage.getItem("user"));
  //   console.log("DATATATA=", userData?.user?.id);
  // const id=userData?.user?.id

  // const id=userData?.domainCodesByUserId[0]?.userId

  // const id = userData?.domainCodesByUserId[0]?.userId;
  const id = userData?.user?.userId;
  const mobileNo1 = userData?.user?.mobile;
  const emailId = userData?.user?.emailId;

  useEffect(() => {
    domain();
  }, []);

  const [deptApp, setDeptApp] = useState([]);

  function domain() {
    dispatch({ type: loader.startLoader });
    // let userId=1791
    let req = {
      userId: id,
      mobileNo: mobileNo1,
      email: emailId,
    };

    adminUserDomainDetails(req, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        setDeptApp(res?.data?.result?.deptApplicationList);
        console.log(
          "domain details=",
          res?.data?.result?.deptApplicationList[0]?.application
        );
      } else {
        console.log(res);
      }
    });
  }
    
    // const settings = {
    //     dots: true,
    //     infinite: false,
    //     speed: 500,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     initialSlide: 0,
    //     responsive: [
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 2,
    //         },
    //       },
    //       {
    //         breakpoint: 600,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1,
    //         },
    //       },
    //     ],
    //   };
   
    
     

  //   const dispatch = useDispatch();
  // const [deptList, setDeptList] = useState([]);
  // const userData = JSON.parse(localStorage.getItem("user"));
  // console.log("DATATATA=", userData?.user?.mobile);
  // const [bhoomiDetails, setBhoomiDetails] = useState([]);

  // useEffect(() => {
  //   dashboardDetails();
  //   schemeDetails();
  // }, []);

  // function schemeDetails() {
  //   console.log("DEKHO");
  //   let mob = 9811090749;
  //   dispatch({ type: loader.startLoader });

  //   citizenSchemeDetails(mob, (res) => {
  //     dispatch({ type: loader.stopLoader });
  //     if (res?.data?.status) {
       
  //       console.log("SCHEME=", res?.data?.result?.bhoomiDashboardDetails);

  //       setBhoomiDetails(res?.data?.result?.bhoomiDashboardDetails);
  //     } else {
  //       console.log(res);
  //     }
  //   });
  // }

  // function dashboardDetails() {
  //   dispatch({ type: loader.startLoader });

  //   citizenDashboardDetails((res) => {
  //     dispatch({ type: loader.stopLoader });
  //     if (res.status) {
      
  //       setDeptList(res?.data?.result?.deptApplicationList);
  //     } else {
      
  //     }
  //   });
  // }
  // var [arr, setArr] = useState([]);
  // const [appDetails, setAppDetails] = useState("0");
  // const [deptHeader, setDeptHeader] = useState("");
  // const [activeCard, setActiveCard] = useState(null);
  // function applicationInfo(ind) {
  //   setAppDetails("2");
  //   console.log("INDEX=", ind);
  //   setDeptHeader(deptList[ind]?.departmentName);
  //   console.log("DATA=", deptList[ind]?.application);
  //   setArr(deptList[ind]?.application);
  //   setActiveCard(ind);

   
  // }

    return(

        <>

<div className="card shadow myprofileCard ">
      <div className="card-body overFlow p-md-3">
        <h5 className="h2_heading">DDA Departments</h5>
        <br></br>
     

        <div className="row marTop">
          <h5>
            {deptApp[0]?.departmentName} Application
          </h5>

          {deptApp?.map((va, i) => (
            <>
              {deptApp[i]?.application?.map((val, j) => (

                <div key={j} className="row marTop">
                  <div className="col-12 card shadow">
                    <div className="card-body">
                      <div className="sameLine2">
                        <img
                          src={"http://4.224.85.195" + val?.icon}
                          className="iconSize2 "
                          alt="delhi"
                        />
                      </div>

                      <div className="sameLine2">
                        <h5>{val?.applicationName}</h5>
                        <p style={{ fontSize: "10px" }}>{val?.description}</p>
                      </div>
                      <div className="sameLine2" style={{ float: "right" }}>
                        <a
                        //   href={val?.url}
                          href={`${val?.url}?token=${token}`}

                          target="_blank"
                          alt="Link Not working"
                        >
                          {" "}
                          {/* <Link
                            to={"/" + val?.domainCode}
                            state={{
                              url_Link: val?.url,
                              doCode: val?.domainCode,
                            }}
                          > */}

                          {console.log( "HERF=",`${val?.url}?token=${token}`)}
                            <button className="btn btn-primary">Open</button>
                          {/* </Link> */}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            </>
          ))}
        </div>
      </div>
    </div>
        

      

        
        {/* <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h5 className="h2_heading">DDA Departments</h5>
      
          <div className="row forSpace">

          <Slider {...settings}>
            {deptList?.map((val, index) => (
              <div
                key={index}
                className="card marTop shadow cardDash "
                onClick={() => {
                  applicationInfo(index);
                }}
              >
                <div className="card-body" style={{ background:activeCard===index?"#e7f1ff":"white"}}>
                  <div className="row">
                    <div className="row">
                      <img
                        src={"http://4.224.85.195" + val.application[0].icon}
                        className="iconSize"
                        alt="delhi"
                      />
                    </div>
                    <div className="row">
                      <h5>{val.departmentName}</h5>
                      <p className="fontSize">{val.deptDis}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            
            </Slider>

            {appDetails === "2" ? (
              <>
                <div className="row marTop">
                  <h5>{deptHeader} Application</h5>

                  {arr?.map((va, i) => (
                    <>
                      <div key={i} className="row marTop">
                        <div className="col-12 card shadow">
                          <div className="card-body">
                            <div className="sameLine2">
                              <img
                                src={"http://4.224.85.195" + va?.icon}
                                className="iconSize2 "
                                alt="delhi"
                              />
                            </div>

                            <div className="sameLine2">
                              <h5>{va?.applicationName}</h5>
                              <p style={{ fontSize: "10px" }}>
                                {va?.description}
                              </p>
                            </div>
                            <div
                              className="sameLine2"
                              style={{ float: "right" }}
                            >
                              <a
                                href={va?.url}
                                target="_blank"
                                alt="Link Not working"
                              >
                                {" "}
                              
                                <button className="btn btn-primary">
                                  Open
                                </button>
                           
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </>
            ) : (
              <></>
            )}
           
          </div>
        </div>
      </div> */}

     
        
        </>
    )
}
export default DeptUserDashboard;